import { Vehicle } from '../../../api/types';
import { ProgressionActivities } from './constants';
import { readUftTransferStatusOverride } from '../../../dev-tools/UftTransferStatus';

export interface ITransferStatus {
    vehicle: Vehicle;
    status: string;
    appointmentTime?: string;
    appointmentType?: string;
}

export type TransferStatus = ITransferStatus;

const emptyTransferStatus: TransferStatus = {
    vehicle: {} as Vehicle,
    status: '',
};

export const fetchAndBuildTransferStatus = async (): Promise<TransferStatus> => {
    const devToolsTransferStatusOverride = readUftTransferStatusOverride();
    if (devToolsTransferStatusOverride) {
        return devToolsTransferStatusOverride;
    }

    // The legacy home-microsite should not ever show a transfer experience due to CA-CARS
    // See https://dev.azure.com/CarMax/Product%20Portfolio/_workitems/edit/407710 for details
    return emptyTransferStatus;
};

export const hasInProgressTransfer = (transfersTile: ITransferStatus): boolean => {
    const inProgressStatuses = [
        ProgressionActivities.TransferOrderRequestSubmitted,
        ProgressionActivities.TransferOrderAwaitingApproval,
        ProgressionActivities.TransferOrderApproved,
        ProgressionActivities.TransferOrderTendered,
        ProgressionActivities.TransferCheckoutCompleted,
        ProgressionActivities.AppointmentScheduled,
        ProgressionActivities.AppointmentConfirmed,
        ProgressionActivities.AppointmentRescheduled,
    ];
    return inProgressStatuses.includes(transfersTile?.status as ProgressionActivities);
};

export const hasCheckoutCreatedTransfer = (transfersTile: ITransferStatus): boolean => {
    return transfersTile?.status === ProgressionActivities.TransferCheckoutCreated;
};
